import { render } from "./ShipPartTable.vue?vue&type=template&id=20fe0046&scoped=true&lang=true"
import script from "./ShipPartTable.vue?vue&type=script&lang=js"
export * from "./ShipPartTable.vue?vue&type=script&lang=js"

import "./ShipPartTable.vue?vue&type=style&index=0&id=20fe0046&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fe0046"]])

export default __exports__